<template>
    <div class="form-group" :class="theClasses">
        <label v-if="!!label" for="">{{ label }} <span v-if="!!required" class="field-required-mark">*</span></label>
        <v-select
            :value="selectedValue"
            :options="formattedOptions"
            :reduce="option => option[fieldKey]"
            :placeholder="placeholder"
            :disabled="disabled"
            :clearable="clearable"
            :searchable="true"
            @input="updateValue"
            label="label"
        ></v-select>
        <span v-if="hasError" class="field-error">{{ errorMessage }}</span>
    </div>
</template>
<script>
    export default {
        props: {
            label: {
                type: String,
                default: ''
            },
            hasError: {
                type: Boolean,
                default: false
            },
            errorMessage: {
                type: String,
                default: ''
            },
            options: {
                type: Array,
                default: () => []
            },
            fieldKey: {
                type: String,
                default: 'id'
            },
            fieldValue: {
                type: String,
                default: 'name'
            },
            placeholder: {
                type: String,
                default: '-- Seleccione --'
            },
            required: {
                default: false
            },
            value: {
                default: ''
            },
            disabled: {
                default: false
            },
            isObject: {
                type: Boolean,
                default: false
            },
            classes: {
                default: ''
            },
            clearable: {
                type: Boolean,
                default: true
            }
        },
        data(){
            return {
                selectedValue: ''
            }
        },
        computed: {
            formattedOptions() {
                return this.options.map(option => ({
                    ...option,
                    label: option[this.fieldValue],
                    value: option[this.fieldKey]
                }));
            },
            theClasses(){
                if(typeof this.classes === 'string'){
                    const classes = {};
                    classes[this.classes] = 1;
                    return classes;
                }

                if(Array.isArray(this.classes)){
                    const classes = {};
                    this.classes.map(theClass => classes[theClass] = 1);
                    return classes;
                }

                if(this.classes && typeof this.classes === 'object' && this.classes.constructor === Object){
                    return this.classes;
                }
            }
        },
        mounted() {
            if (this.value !== undefined && this.value !== null && this.value !== '') {
                this.selectedValue = this.isObject ? this.value[this.fieldKey] : this.value;
            }
        },
        watch: {
            options(val){
                if(!this.value) return;
                this.selectedValue = !!this.isObject ? this.value[this.fieldKey] : this.value;
            },
            value(val){
                // Actualizar selectedValue cuando cambia el prop value
                if (val !== undefined && val !== null && val !== '') {
                    this.selectedValue = !!this.isObject ? val[this.fieldKey] : val;
                } else {
                    this.selectedValue = '';
                }
            }
        },
        methods: {
            updateValue(val){
                const result = this.isObject ? this.options.find(item => item[this.fieldKey] === val) : val;
                this.selectedValue = val;
                this.$emit('input', result);
                this.$emit('change', result);
            }
        }
    }
</script>
<style scoped>
    /* Estilos para vue-select */
    ::v-deep .v-select {
        width: 100%;
    }
    
    ::v-deep .v-select .vs__dropdown-toggle {
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        min-height: 38px;
    }
    
    ::v-deep .v-select .vs__dropdown-toggle:focus {
        border-color: #80bdff;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
    
    ::v-deep .v-select.vs--open .vs__dropdown-toggle {
        border-color: #80bdff;
    }
    
    ::v-deep .v-select .vs__search::placeholder {
        color: #6c757d;
    }
    
    ::v-deep .v-select .vs__clear {
        fill: #6c757d;
    }
    
    ::v-deep .v-select .vs__open-indicator {
        fill: #6c757d;
    }
</style>

